module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="comment-header">\n    <div class="comment-icon">\n        <div class="unread-comments-indicator-wrapper"><div class="unread-comments-indicator"></div></div>\n    </div>\n    <a href="#" class="comment-delete"></a>\n</div>\n<div class="comment-collection-region"></div>\n<div class="comment-reply-wrapper">\n    <div class="comment-reply">\n        <textarea placeholder="Write comment"></textarea>\n        <div class="comment-reply-sizer"></div>\n        <div class="comment-reply-icon"></div>\n    </div>\n</div>';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/comments/CommentView.tpl
// module id = 2973
// module chunks = 0